const state = {
  gradingSystems: [
    {
      code: "fr",
      label: "frenchGradingSystemLabel",
      maxGrade: 20,
    },
    {
      code: "de",
      label: "germanGradingSystemLabel",
      maxGrade: 6,
    },
  ],
};

const getters = {
  getGradingSystems: (state) => {
    return state.gradingSystems;
  },
  getGradingSystemByCode: (state) => (code) => {
    const gradingSystem = state.gradingSystems.find((el) => el.code === code);
    return gradingSystem ? gradingSystem : null;
  },
  getDefaultGradingSystem: (state) => {
    return state.gradingSystems.find((el) => el.code === "fr");
  },
};

const actions = {};
const mutations = {};

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations,
};
